import { create } from "zustand";

export interface TranscriptItem {
  text: string;
  originalText?: string;
  isRefined: boolean;
}

export interface RealtimeSttState {
  finalTranscripts: TranscriptItem[];
  currentTranscript: string;
  filePath: string | null;
  isRecording: boolean;
  elapsedTime: number;
  timerInterval: NodeJS.Timeout | null;
  audioFile: File | null;
  alertMessage: string | null;
  summary: string | null;
  topic: string | null;
  addFinalTranscript: (transcript: string, isRefined?: boolean, originalText?: string) => void;
  setCurrentTranscript: (transcript: string) => void;
  setFilePath: (path: string | null) => void;
  startRecording: () => void;
  stopRecording: () => void;
  resetTranscripts: () => void;
  setAudioFile: (file: File | null) => void;
  setAlertMessage: (message: string | null) => void;
  setSummaryAndTopic: (summary: string | null, topic: string | null) => void;
}

export const useRealtimeSttStore = create<RealtimeSttState>((set, get) => ({
  finalTranscripts: [],
  currentTranscript: "",
  filePath: null,
  isRecording: false,
  elapsedTime: 0,
  timerInterval: null,
  audioFile: null,
  alertMessage: null,
  summary: null,
  topic: null,
  addFinalTranscript: (transcript: string, isRefined: boolean = false, originalText?: string) => {
    // 한 글자 짜리 단어는 무시
    if (transcript.length <= 1) {
      return;
    }
    set((state) => ({
      finalTranscripts: [...state.finalTranscripts, { 
        text: transcript, 
        originalText,
        isRefined 
      }],
      currentTranscript: "",
    }));
  },
  setCurrentTranscript: (transcript: string) =>
    set({ currentTranscript: transcript }),
  setFilePath: (path) => set({ filePath: path }),
  startRecording: () => {
    const { timerInterval } = get();
    if (timerInterval) return;

    const newInterval = setInterval(() => {
      set((state) => ({ elapsedTime: state.elapsedTime + 1 }));
    }, 1000);

    set({
      isRecording: true,
      timerInterval: newInterval,
      elapsedTime: 0,
      finalTranscripts: [],
      currentTranscript: "",
      summary: null,
      topic: null,
    });
  },
  stopRecording: () => {
    const { timerInterval } = get();
    if (timerInterval) {
      clearInterval(timerInterval);
    }
    set({ isRecording: false, timerInterval: null });
  },
  resetTranscripts: () => {
    set({
      finalTranscripts: [],
      currentTranscript: "",
      summary: null,
      topic: null,
    });
  },
  setAudioFile: (file) => set({ audioFile: file }),
  setAlertMessage: (message) => set({ alertMessage: message }),
  setSummaryAndTopic: (summary, topic) => set({ summary, topic }),
}));
